<template>
    <div>

        <b-modal id="create-or-update-education-info" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <employee-education-create-or-update v-model="education"></employee-education-create-or-update>
            <template #modal-footer><v-executer  :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>
        
        <v-table    ref="table"
                    search
                    with-items
                    up-class="px-1 pb-1"
                    :items="value"
                    :add-callback="createNew"
                    :buttons="buttons"
                    name="employee-education"
                    overlay-class="pb-0"
                    :fields="fields"></v-table>

    </div>
</template>

<script>
import EmployeeEducationCreateOrUpdate from './EmployeeEducationCreateOrUpdate.vue'
import randomatic from 'randomatic'
import moment from 'moment'

export default {
    components:{
        EmployeeEducationCreateOrUpdate
    },
    props:{
        value:Array,
        id:[String,Number]
    },
    data(){
        return{
            editing:false,
            fields:[
                {name:"Eğitim Durumu",key:"EducationStatusName",thClass:"w-17"},
                {name:"Kurum",key:"Value",thClass:"w-17",tdClass:'text-nowrap'},
                {name:"Başlangıç Tarihi",key:"StartTimeVisual",thClass:"w-17"},
                {name:"Bitiş Tarihi",key:"EndTimeVisual",thClass:"w-17"},
                {name:"Mezuniyet Puanı",key:"Degree",thClass:"w-16"},
                {name:"Diploma Numarası",key:"CertificateNumber",thClass:"w-16"},
                {name:"Mezun",key:"Graduated"},
                
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            education:{
                UniversityId:null,
                UniversityName:null,
                UniversityDepartmentId:null,
                UniversityDepartmentName:null,
                Value:null,
                EducationStatusId:null,
                EducationStatusName:null,
                StartTime:null,
                StartTimeVisual:null,
                EndTime:null,
                EndTimeVisual:null,
                Graduated:false,
                Degree:null,
                CertificateNumber:null,
            },
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.education.Id = null
            this.education.UniversityId = null
            this.education.UniversityName = null
            this.education.UniversityDepartmentId = null
            this.education.UniversityDepartmentName = null
            this.education.Value = null
            this.education.EducationStatusId = null
            this.education.EducationStatusName = null
            this.education.StartTime = null
            this.education.StartTimeVisual = null
            this.education.EndTime = null
            this.education.EndTimeVisual = null
            this.education.Graduated = false
            this.education.Degree = null
            this.education.CertificateNumber = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update-education-info')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.education.Id = item.Id
            this.education.UniversityId = item.UniversityId
            this.education.UniversityName = item.UniversityName 
            this.education.UniversityDepartmentId = item.UniversityDepartmentId
            this.education.UniversityDepartmentName = item.UniversityDepartmentName
            this.education.Value = item.Value
            this.education.EducationStatusId = item.EducationStatusId 
            this.education.EducationStatusName = item.EducationStatusName
            this.education.StartTime = item.StartTime
            this.education.StartTimeVisual = item.StartTimeVisual
            this.education.EndTime = item.EndTime
            this.education.EndTimeVisual = item.EndTimeVisual
            this.education.Graduated = item.Graduated
            this.education.Degree = item.Degree
            this.education.CertificateNumber = item.CertificateNumber
            this.$showModal('create-or-update-education-info')
        },
        // todo
        createOrUpdate(){
            if(this.education.Id){
                let item = this.value.find(r=> r.Id == this.education.Id)
                this.$set(item,"UniversityId",this.education.UniversityId)
                this.$set(item,"UniversityName",this.education.UniversityName)
                this.$set(item,"UniversityDepartmentId",this.education.UniversityDepartmentId)
                this.$set(item,"UniversityDepartmentName",this.education.UniversityDepartmentName)
                this.$set(item,"Value",this.education.Value || [
                    this.education.UniversityName || null, this.education.UniversityDepartmentName
                ].filter(s=>s).join('-'))
                this.$set(item,"EducationStatusId",this.education.EducationStatusId)
                this.$set(item,"EducationStatusName",this.education.EducationStatusName)
                this.$set(item,"StartTime",this.education.StartTime)
                this.$set(item,"StartTimeVisual", moment(this.education.StartTime,'YYYY-MM-DD').format('DD.MM.YYYY'))
                this.$set(item,"EndTime",this.education.EndTime)
                this.$set(item,"EndTimeVisual",moment(this.education.EndTime,'YYYY-MM-DD').format('DD.MM.YYYY'))
                this.$set(item,"Graduated",this.education.Graduated)
                this.$set(item,"Degree",this.education.Degree)
                this.$set(item,"CertificateNumber",this.education.CertificateNumber)
                this.$set(item,"Unsaved",true)
            }else{
                this.value.push({
                    Id:randomatic("A0",10),
                    UniversityId:this.education.UniversityId,
                    UniversityDepartmentId:this.education.UniversityDepartmentId,
                    Value:(this.education.Value || [
                        this.education.UniversityName || null, this.education.UniversityDepartmentName
                    ].filter(s=>s).join('-')),
                    EducationStatusId:this.education.EducationStatusId,
                    EducationStatusName:this.education.EducationStatusName,
                    StartTime:this.education.StartTime,
                    StartTimeVisual:moment(this.education.StartTime,'YYYY-MM-DD').format('DD.MM.YYYY'),
                    EndTime:this.education.EndTime,
                    EndTimeVisual:moment(this.education.EndTime,'YYYY-MM-DD').format('DD.MM.YYYY'),
                    Graduated:this.education.Graduated,
                    Degree:this.education.Degree,
                    CertificateNumber:this.education.CertificateNumber,
                    Unsaved:true
                })
            }
            this.$hideModal('create-or-update-education-info')
        },
        delete(item,key,index){
            this.$confirm("Silmek istediğinize emin misiniz?",`Bu işlem eğitim bilgisini silecektir ve geri alınamaz.`).then(res=>{
                if(res){
                    this.$delete(this.value,index)
                }
            })
        },
    }
}
</script>

<style>

</style>